var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 .438A9.563 9.563 0 1019.563 10 9.574 9.574 0 0010 .437zm0 18A8.438 8.438 0 1118.438 10 8.447 8.447 0 0110 18.438zM15.813 10a.563.563 0 01-.563.563H10A.562.562 0 019.437 10V4.75a.563.563 0 011.126 0v4.688h4.687a.563.563 0 01.563.562z",
    fill: "#5B576A"
  })));
}

export default SvgCalendarTime;